import React, { useEffect } from 'react';

/**
 * this component is rendered at the root route and will take care of setting
 * a current client if one is not already set by another, higher priority route
 */
export default function SetDefaultCurrentClient({
    currentUser,
    currentClient,
    localCurrentClient,
}) {
    // this useEffect deliberately does not have dependencies as we only
    // want to fire a single time on mount
    useEffect(() => {
        if (localCurrentClient) {
            return;
        }

        if (
            !currentUser ||
            !currentUser.clients ||
            currentUser.clients.length < 1
        ) {
            return;
        }

        currentClient.next(currentUser.clients[0]);
    }, []);

    return null;
}
